import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { EditorData } from "../../state/SearchManagerV2/EditorData";

const updateSearchManagerV2EditorData: Reducer<EditorData> = (state: EditorData = new EditorData(), action: Action<ActionType, EditorData>) => {
  switch (action.type) {
    case ActionType.SEARCH_MANAGER_V2_EDITOR_DATA_RESET:
      return new EditorData();
    case ActionType.SEARCH_MANAGER_V2_EDITOR_DATA_FETCHED:
      return { ...state, searchManagerEditorData: action.data };
    case ActionType.SEARCH_MANAGER_V2_EDITOR_DATA_COPIED:
      return { ...state, searchManagerEditorData: { ...action.data} };
    case ActionType.SEARCH_MANAGER_V2_EDITOR_DATA_UPDATED:
      let result = { ...state, searchManagerEditorData: { ...state.searchManagerEditorData, ...action.data } }
      return result;
    case ActionType.SEARCH_MANAGER_V2_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.SEARCH_MANAGER_V2_EDITOR_DATA_VALIDATED:
      return { ...state, validation: {...action.data }};
    case ActionType.SEARCH_MANAGER_V2_EDITOR_SET_BOUND_ITEM:
      return {...state, searchManagerEditorData: {...state.searchManagerEditorData, ...action.data}}
    default:
      return state;
  }
};

export default updateSearchManagerV2EditorData;
